import { render, staticRenderFns } from "./HostingComparativa.vue?vue&type=template&id=4eee363e&scoped=true"
import script from "./HostingComparativa.vue?vue&type=script&lang=js"
export * from "./HostingComparativa.vue?vue&type=script&lang=js"
import style0 from "./HostingComparativa.vue?vue&type=style&index=0&id=4eee363e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee363e",
  null
  
)

export default component.exports